import { ChangeDetectionStrategy, Component, ContentChild, HostListener, Input } from '@angular/core';
import { RadioComponent } from '../../../radio/radio.component';

@Component({
  selector: 'lp2-teacher-switch-fallback-item',
  template: `
    <ng-content select="lp2-radio"></ng-content>
    <div>
      <p class="label">{{ label | translate }}</p>
      <p *ngIf="description" class="description">{{ description | translate }}</p>
    </div>
  `,
  styleUrls: ['./teacher-switch-fallback-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.teacher-switch-fallback-item--checked]': 'isChecked'
  }
})
export class TeacherSwitchFallbackItemComponent {
  @ContentChild(RadioComponent) private _radioComponent: RadioComponent;
  @Input() public label: string;
  @Input() public description: string;

  public get isChecked(): boolean {
    if (this._radioComponent) {
      return this._radioComponent.checked;
    }
  }

  @HostListener('click') public check() {
    if (this._radioComponent) {
      this._radioComponent.check();
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/teacher-switch-modal/teacher-switch-fallback-item/teacher-switch-fallback-item.component.ts